import { joinBy } from '@pbk/utils';
import { v4 as uuidv4 } from 'uuid';

import type { AnalyticsProcess } from '../constants';

export type AnalyticsProcessId = string;

export const createAnalyticsProcessId = (
	analyticsProcess: AnalyticsProcess,
): AnalyticsProcessId => joinBy([analyticsProcess, uuidv4()], '_');
